import {FETCH_NOTIFICATION_SETTING_SUCCESS,} from "../../constants/ActionTypes";

const INIT_STATE = {
  data:'',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_SETTING_SUCCESS: {
      return {
        ...state,
        data: action.data,
      }
    }
    default:
      return state;
  }
}
